import axios from "axios";

export type CepAddressType = {
    cep: string;
    street: string;
    neighborhood: string;
    city: string;
    /** Sigla do estado (UF). */
    state: string;
};

const TIMEOUT_MS = 8000;

/** Erro no formato que o useDirectdLookup ja entende (response.data.reason / status). */
const notFound = () => Object.assign(new Error("CEP não encontrado."), {
    response: { data: { status: "NOT_FOUND", reason: "CEP não encontrado." } },
});

/**
 * findAddressByCep - Busca o endereco de um CEP (8 digitos) no ViaCEP, gratuito e sem token.
 * Se o ViaCEP estiver fora do ar, tenta a BrasilAPI. CEP inexistente nao cai no fallback.
 * @async-function
 */
const findAddressByCep = async (cep: string): Promise<CepAddressType> => {
    try {
        const { data } = await axios.get(`https://viacep.com.br/ws/${cep}/json/`, { timeout: TIMEOUT_MS });
        // O ViaCEP responde 200 com {"erro": true} (ou "true") para CEP inexistente.
        if (data?.erro) throw notFound();
        return {
            cep,
            street: data.logradouro ?? "",
            neighborhood: data.bairro ?? "",
            city: data.localidade ?? "",
            state: data.uf ?? "",
        };
    } catch (error: any) {
        if (error?.response?.data?.status === "NOT_FOUND") throw error;
    }

    try {
        const { data } = await axios.get(`https://brasilapi.com.br/api/cep/v1/${cep}`, { timeout: TIMEOUT_MS });
        return {
            cep,
            street: data.street ?? "",
            neighborhood: data.neighborhood ?? "",
            city: data.city ?? "",
            state: data.state ?? "",
        };
    } catch (error: any) {
        if (error?.response?.status === 404) throw notFound();
        // Sem response: o useDirectdLookup trata como falha de rede e libera nova tentativa.
        throw new Error("Serviço de CEP indisponível.");
    }
};

export default findAddressByCep;
